import { render, staticRenderFns } from "./TopSupportQuestions.vue?vue&type=template&id=1481390d&"
import script from "./TopSupportQuestions.vue?vue&type=script&lang=js&"
export * from "./TopSupportQuestions.vue?vue&type=script&lang=js&"
import style0 from "./TopSupportQuestions.vue?vue&type=style&index=0&id=1481390d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports